import clsx from "clsx";
import { Button, Dropdown } from "react-daisyui";
import { LuLanguages } from "react-icons/lu";

import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { getLanguage } from "@/redux/app/appSelector";
import { appActions } from "@/redux/app/appSlice";

export default function Language({ className }: { className: string }) {
  const dispatch = useAppDispatch();
  const language = useAppSelector(getLanguage);

  return (
    <Dropdown className={className} end>
      <Dropdown.Toggle button={false}>
        <Button className="w-[4.6rem]" color="ghost" shape="circle">
          <LuLanguages className="h-5 w-5" />
          {language.slice(0, 2).toUpperCase()}
        </Button>
      </Dropdown.Toggle>

      <Dropdown.Menu className="mt-3 w-36">
        <Dropdown.Item
          className={clsx({ active: language.includes("en") })}
          onClick={() => dispatch(appActions.setLanguage("en-US"))}
        >
          English (US)
        </Dropdown.Item>
        <Dropdown.Item
          className={clsx({ active: language.includes("en-GB") })}
          onClick={() => dispatch(appActions.setLanguage("en-GB"))}
        >
          English (UK)
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
